import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 6, height: 3, fill: "#008751" }), /* @__PURE__ */ React.createElement("rect", { x: 2, width: 2, height: 3, fill: "#FFF" }));
const ForwardRef = forwardRef(SvgNg);
const Memo = memo(ForwardRef);
export default Memo;
